import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideocamIcon(props: IconProps) {
    return <Icon {...props} iconKey={"videocam"}/>
}
